export class WorkOrderWarning {
  constructor(public actionName: string, public warnings: string[]) {
    this.actionName = actionName;
    this.warnings = warnings;
  }
}
